import logo1 from '../assets/img/png/logo-paybito.png' 
import logo2 from '../assets/img/png/logo-white-paybito.png' 
import dafaultNftImage from '../assets/img/png/default-nft.png' 

export const PROJECTNAME = localStorage.getItem('nftBrokerExchangeName')+' Marketplace';
export const PROJECTNAMEALIAS = localStorage.getItem('nftBrokerExchangeName')+'_nft_';
export const PROJECTLOGOPRIMARY = localStorage.getItem('nftBrokerlogo');
export const PROJECTLOGOSECONDARY = localStorage.getItem('nftBrokerlogo');
export const DEFAULTNFTIMAGE = dafaultNftImage;
//export const PROJECTCLIENTSIDEURL = 'http://localhost:3000/nft-marketplace' //NOTE: for development
export const PROJECTCLIENTSIDEURL = window.location.origin+'/nft-marketplace' //NOTE: for production
export const PROJECTCAPTCHASITEKEY = '6Lez17ghAAAAAN3YKQBlsAa5K_AS-x1PzAWQOoKl'
export const MAXTIMELIMITFOREMAILOTP = 120;
export const MAXTIMELIMITFORPHONEOTP = 120;
export const NFTAPIBASENAME = 'https://accounts.paybito.com/api'
export const PAYBITOAPIBASENAME = 'https://accounts.paybito.com/api'
export const COLLECTIONIMAGEBASEURL = 'https://paybito-nft-marketplace.s3.us-west-1.amazonaws.com/collections_data'
export const USERCOLLECTIONIMAGEBASEURL = 'https://paybito-nft-marketplace.s3.us-west-1.amazonaws.com/users_data'
export const NFTIMAGEBASEURL = 'https://paybito-nft-marketplace.s3.us-west-1.amazonaws.com/nfts_data'


export const ERC721ABI = [
    {
      "constant": false,
      "inputs": [
        { "name": "to", "type": "address" },
        { "name": "tokenId", "type": "uint256" }
      ],
      "name": "approve",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "constant": true,
      "inputs": [
        { "name": "tokenId", "type": "uint256" }
      ],
      "name": "getApproved",
      "outputs": [{ "name": "", "type": "address" }],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "constant": false,
      "inputs": [
        { "name": "operator", "type": "address" },
        { "name": "approved", "type": "bool" }
      ],
      "name": "setApprovalForAll",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "constant": true,
      "inputs": [
        { "name": "owner", "type": "address" },
        { "name": "operator", "type": "address" }
      ],
      "name": "isApprovedForAll",
      "outputs": [{ "name": "", "type": "bool" }],
      "stateMutability": "view",
      "type": "function"
    },
  {
    "constant": false,
    "inputs": [
      { "name": "from", "type": "address" },
      { "name": "to", "type": "address" },
      { "name": "tokenId", "type": "uint256" }
    ],
    "name": "safeTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      { "name": "from", "type": "address" },
      { "name": "to", "type": "address" },
      { "name": "tokenId", "type": "uint256" },
      { "name": "data", "type": "bytes" }
    ],
    "name": "safeTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
  ];
  
